import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { FEED_OPTIONS } from "%/dynamic-component-editor/constants/feed-options";
import SmartFeedSelection from "%/dynamic-component-editor/options/smart-feed-selection";

export default class SmartFeedFiltersToShow extends BaseOption {
  static label = "Filters";

  static defaultValue = [];

  static hardcodedSourceName = null;

  static resolveSourceName(optionValues) {
    if (this.hardcodedSourceName) {
      return this.hardcodedSourceName;
    }
    return new SmartFeedSelection().getValueFromConfiguration(optionValues);
  }

  static userInterfaceComponent(optionValues) {
    const selectedFeed = this.resolveSourceName(optionValues);
    const feedConfig = FEED_OPTIONS[selectedFeed];
    const availableFilters = feedConfig?.availableFilters ?? [];

    return {
      component: inspectorTools.FILTER_CONFIGURATOR,
      props: {
        options: availableFilters,
      },
    };
  }
}
